<h2 mat-dialog-title>Bulk Import Games</h2>
<mat-dialog-content>
  <div class="dialog-content">
    <p class="instructions">
      Upload a CSV file to create multiple games at once. All rows must be valid
      for the import to succeed.
    </p>

    <div class="template-section">
      <button mat-stroked-button color="primary" (click)="downloadTemplate()">
        <mat-icon>download</mat-icon>
        Click here for a template
      </button>
    </div>

    <div class="file-input-section">
      <input
        #fileInput
        type="file"
        accept=".csv"
        (change)="onFileSelected($event)"
        [disabled]="loading"
        style="display: none"
      />
      <button
        mat-raised-button
        color="primary"
        matTooltip="Max file size: 20MB. Max number of rows: 1000."
        (click)="clearSelectedFile(); fileInput.click()"
        [disabled]="loading"
      >
        <mat-icon>upload_file</mat-icon>
        Upload File
      </button>
      <span *ngIf="fileName" class="file-name">{{ fileName }}</span>
    </div>

    <div *ngIf="validationErrors.length > 0" class="validation-errors">
      <h3>Validation Errors</h3>
      <ul>
        <li *ngFor="let err of validationErrors">
          <strong
            >Row {{ err.row }},
            {{ err.fields.join(', ') }}:</strong
          >
          {{ err.message }}
        </li>
      </ul>
    </div>

    <div *ngIf="error" class="error-message">
      <mat-icon>error</mat-icon>
      {{ error }}
    </div>

    <mat-progress-bar
      *ngIf="loading"
      mode="indeterminate"
      color="primary"
    ></mat-progress-bar>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()" [disabled]="loading">Cancel</button>
  <button
    mat-raised-button
    color="primary"
    (click)="import()"
    [disabled]="loading || !selectedFile"
  >
    <mat-icon>cloud_upload</mat-icon>
    Import
  </button>
</mat-dialog-actions>
